import get from 'lodash/get';
import { IsInt, IsOptional, Min, ValidateIf } from 'class-validator';

enum MessageType {
  RECORDING = 'RECORDING',
  TEXT = 'TEXT',
}

type Message = { message: string; type: MessageType };

export default class VoiceConfiguration {
  id: string;
  name?: string;
  number: string;

  @IsOptional()
  initialIvrId?: string;

  @IsOptional()
  queueIvrId?: string;

  @ValidateIf(props => get(props, 'queueIvrId'))
  @IsInt()
  @Min(1, { message: 'Enter a value greater than 0' })
  queueIvrWaitDuration: number;

  holdMessage?: Message;
  queueUrl?: string;
}
